import { ReactComponent as Logo } from "assets/icons/Logo.svg";
import { Box } from "components/common";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import MainDrawer from "./drawer";
import Header from "./header";
import useFunctions from "./ts/useFunctions";

export default function DashboardLayout() {
  const { loading, open } = useFunctions();

  return (
    <>
      <Header />
      <MainDrawer />
      <Box
        sx={{
          marginTop: "90px",
          padding: { xs: "10px", sm: "20px" },
          marginLeft: { xs: 0, lg: open ? "300px" : "105px" },
          marginRight: { xs: 0, sm: "20px" },
          marginBottom: { xs: 0, sm: "20px" },
          color: "white",
          bgcolor: "#0A0A0A",
          height: { xs: "auto", sm: "calc(100vh - 150px)" },
          borderRadius: { xs: 0, sm: "20px" },
          transitionProperty: "all",
          transitionDuration: "225ms",
          boxSizing: "border-box",
          overflow: { xs: "auto", sm: "hidden" },
          WebkitOverflowScrolling: "touch",
          position: "relative",
        }}
      >
        <Suspense>
          <Outlet />
        </Suspense>
        {loading && (
          <Box
            id="dashboard-loader"
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100%"
            position="absolute"
            top={0}
            left={0}
            bgcolor="#0A0A0A"
            zIndex={100}
          >
            <Logo
              width={150}
              style={{
                animation: "1s fadeInOut infinite",
              }}
            />
          </Box>
        )}
      </Box>
    </>
  );
}
